import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class UnsavedChangesService {
  onSave!: () => void;
  hasChanges$!: Observable<boolean>;

  register(onSave: () => void, hasChanges: Observable<boolean>): void {
    this.onSave = onSave;
    this.hasChanges$ = hasChanges;
  }

  unregister(): void {
    this.onSave = null;
    this.hasChanges$ = null;
  }
}
